import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Ensure App.tsx is correctly exported and in the src folder

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
